import React, { useEffect } from 'react';

import {
    shouldShowPostLoginContinueAlert,
    useContinueOrgEnrollment,
    OrganizationEnrollmentProgress,
} from '../components/useContinueOrgEnrollment';

import { LoadingScreen } from 'components/loading-screen/LoadingScreen';
import { withAuth } from 'features/auth/components/withAuth';
import { useLocation } from 'react-router-dom';

interface OrgEnrollmentContinueProps {
    onProgressLoaded: (progress: OrganizationEnrollmentProgress) => void;
}

export const OrgEnrollmentContinue = withAuth()((props: OrgEnrollmentContinueProps) => {
    const { onProgressLoaded } = props;
    const { search } = useLocation();
    const shouldForceExistingAccountContinuation = shouldShowPostLoginContinueAlert(search);
    const { getContinueAlert, getEnrollmentProgress, getOrgApprovedAlertIfNeeded } =
        useContinueOrgEnrollment();
    useEffect(() => {
        const loadProgress = async () => {
            const progress = await getEnrollmentProgress();
            if (shouldForceExistingAccountContinuation) {
                await getContinueAlert();
            } else {
                await getOrgApprovedAlertIfNeeded(progress);
            }
            if (progress.version === 1 || shouldForceExistingAccountContinuation) {
                onProgressLoaded(progress);
            }
        };
        loadProgress();
    }, [
        getContinueAlert,
        getEnrollmentProgress,
        onProgressLoaded,
        getOrgApprovedAlertIfNeeded,
        shouldForceExistingAccountContinuation,
    ]);

    return <LoadingScreen />;
});
